import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import "../src/design/app.scss";
import store from '@/state/store'
import App from './App.vue'
import VueBootstrapToasts from "vue-bootstrap-toasts";
import excel from 'vue-excel-export' 
import tinymce from 'vue-tinymce-editor'
import VueQRCodeComponent from 'vue-qrcode-component'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import "../src/design/app.scss";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component('qr-code', VueQRCodeComponent)
Vue.use(VueFormWizard)
Vue.component('tinymce', tinymce)
Vue.component("v-select", vSelect);
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false
Vue.use(excel)
Vue.use(VueBootstrapToasts);
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674',
};
Vue.use(VueSweetalert2, options);
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
